import { LIGHT_BLUE_2, BLACK, LIGHT_BLUE_3, GRAY_400 } from "../../constant/colors";

export const ActionsMenuStyle = `
    border-radius: 8px;
    padding: 0;
    min-width: 140px;
    width: max-content;
    .ant-dropdown-menu-item {
        padding: 8px 12px 8px 12px;
        white-space: nowrap;
    }
    .ant-dropdown-menu-item:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .ant-dropdown-menu-item:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
    .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled){
        background-color: ${LIGHT_BLUE_2};

    }
    .ant-dropdown-menu-item:nth-child(1):hover:not(.ant-dropdown-menu-item-disabled) svg rect{
            fill:${LIGHT_BLUE_2}
    }
    .ant-dropdown-menu-item {
        color: ${BLACK} ;
        font-size: 14px;
        font-weight: 400;

    }
    .ant-dropdown-menu-item {
        user-select: none;
    }
    .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled) span{
        color: ${LIGHT_BLUE_3};

    }
    .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled) span > .anticon {
        color: ${BLACK};
    }
    /* Prevent hover effects on disabled items */
    .ant-dropdown-menu-item-disabled:hover {
        background-color: transparent !important;
        cursor: not-allowed !important;
    }
    .ant-dropdown-menu-item-disabled:hover span {
        color: ${GRAY_400} !important;
    }
`;
